import { render, staticRenderFns } from "./BarraSuperior.vue?vue&type=template&id=34e6850f&"
import script from "./BarraSuperior.vue?vue&type=script&lang=js&"
export * from "./BarraSuperior.vue?vue&type=script&lang=js&"
import style0 from "./BarraSuperior.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports